import { apiGet } from 'api';
import { GetFilterAuthoritiesResponse } from '../../types';

export const getFilterAuthorities = (): Promise<GetFilterAuthoritiesResponse> =>
  apiGet<GetFilterAuthoritiesResponse>('authorities');
